<template>
  <div
    class="transaction-status"
    :class="`transaction-status--${mode}`"
    :style="{
      color: operationStatus.color || '#000000',
      backgroundColor: operationStatus.backgroundColor || '#ffffff',
    }"
  >
    <div
      class="transaction-status__mark"
      :style="{
        backgroundColor: operationStatus.markBackgroundColor || '#000000',
      }"
    ></div>
    {{ isMobile ? $t(operationStatus.shortName) : $t(operationStatus.name) }}
  </div>
</template>

<script>
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import { STATUSES_GROUPS_EXTENDED } from '@js-app/const/operation-statuses-groups'
import { OPERATION_STATUSES } from '@js-app/const/operation-statuses'

export default {
  name: 'TransactionStatus',
  mixins: [responsiveMixin],
  props: {
    statusId: {
      type: [Number, String],
      required: true,
    },
    mode: {
      type: String,
      default: 'full',
    },
  },
  computed: {
    operationStatus() {
      return STATUSES_GROUPS_EXTENDED[OPERATION_STATUSES[this.statusId]]
    },
  },
}
</script>

<style lang="scss" scoped>
.transaction-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 22px;
  border-radius: 27px;
  font-weight: 600;
  font-size: 11px;
  line-height: 20px;
  &__mark {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 4px;
    display: block;
  }

  &--plain {
    width: auto;
    height: auto;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    background: none !important;
    border-radius: 0;
    justify-content: flex-start;
  }

  &--plain & {
    &__mark {
      display: none;
    }
  }
}
@media screen and (max-width: 992px) {
  .transaction-status {
    width: auto;
    padding-left: 4px;
    padding-right: 4px;
    min-width: 80px;
  }
}
</style>
